import type { CSSProperties, ReactNode } from 'react'

/*
  FormField — envoltorio label + control + hint. Envuelve `.form-group`,
  `.form-label` y `.form-hint`. El control (input/select/textarea) va como children
  usando las clases `.form-input` / `.form-select` / `.form-textarea`.
*/
interface FormFieldProps {
  label?: ReactNode
  hint?: ReactNode
  htmlFor?: string
  children: ReactNode
  style?: CSSProperties
}

export function FormField({ label, hint, htmlFor, children, style }: FormFieldProps) {
  return (
    <div className="form-group" style={style}>
      {label && <label className="form-label" htmlFor={htmlFor}>{label}</label>}
      {children}
      {hint && <div className="form-hint">{hint}</div>}
    </div>
  )
}
